// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"320":"11a3e47c4495af77","423":"91793257c5882247","731":"ef0b8fef8b15dfb7","957":"387a1045e8e22f5f"}[chunkId] + ".js";
};